<template>
    <div class="mx-3"> 
        <transmission-filter-modal @filter="filter"></transmission-filter-modal>
        <forward-transmission-modal :contacts="contacts"></forward-transmission-modal>
        <transmission-details-modal></transmission-details-modal>
        <div class="row border-bottom mx-1">
            <h2 class="mr-auto">Sent Items</h2>
            <div v-if="clients.length > 1" class="col-3">
                <select :class="['custom-select mr-3', { 'text-primary' : !clientId }]" v-model="clientId" @change="onChange($event)">
                    <option value="">All Clients</option>
                    <option v-for="option in clients" :key="option.id" :value="option.id" v-text="option.name"></option>
                </select>        
            </div>
            <button type="button" class="btn btn-primary mb-1" title="Filter Sent Items" @click="showFilters()">
                <i class="fas fa-filter fa-lg"></i>
            </button>            
        </div>
        <div class="table-responsive">
            <table class="table table-sm">
                <thead>
                    <tr> 
                        <th class="fit">Status</th>
                        <th>Document Type</th>
                        <th>Claim Number</th>
                        <th>Patient Name</th> 
                        <th>Sent By</th>
                        <th v-if="!clientId">Client</th>
                        <th>Completed</th>                              
                        <th class="fit"></th>
                    </tr>
                </thead>
                <tbody v-if="transmissions.length">
                    <template v-for="transmission in transmissions">
                        <tr class="table-stripe" :key="'transmission-list-' + transmission.id">
                            <td class="fit">
                                <a href="javascript:void(0)" class="pr-1" @click="transmission.detail_visible = !transmission.detail_visible">
                                    <i :class="['fas fa-lg text-muted', transmission.detail_visible ? 'fa-caret-down' : 'fa-caret-right']"></i> 
                                </a>                             
                                <i :class="transmissionStatusIcon(transmission.transmission_status_code)"></i>
                            </td>
                            <td>{{ transmission.document_type.name }}</td>
                            <td><a :href="'/claims/' + transmission.claim.id">{{ transmission.claim.claim_number }}</a></td>                                 
                            <td><a :href="'/claims/' + transmission.claim.id">{{ transmission.claim.patient_name }}</a></td>
                            <td>{{ transmission.initiated_by.last_name }}</td>
                            <td v-if="!clientId">{{ transmission.claim.client.name }}</td>
                            <td>
                                <span v-if="transmission.transmission_method_id === TransmissionMethod.MAILED">{{ transmission.completed_at | localizeTime('YYYY-MM-DD') }}</span>
                                <span v-else>{{ transmission.completed_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</span>
                            </td>
                            <td class="fit text-right">
                                <div class="d-flex justify-content-between">
                                    <div class="pr-2 flex-fill">
                                        <a href="javascript:void(0)" class="btn btn-link btn-sm p-0" title="View Transmission Details" @click="showDocuments(transmission)">
                                            <i class="fas fa-info-circle fa-lg"></i>
                                        </a>                                        
                                    </div>
                                    <div class="pr-2 flex-fill">
                                        <a :href="transmission.archive_url" target="_blank" class="btn btn-link btn-sm p-0" title="Download Transmission Archive">
                                            <i class="fas fa-file-archive fa-lg"></i>
                                        </a>
                                    </div>
                                    <div class="flex-fill">
                                        <transmit-button v-if="transmission.completed_at" icon="fa-share" text="Forward" :object="transmission" @click="clickForward" :emailEnabled="emailEnabled" :disabled="transmission.transmissions_disabled"></transmit-button>
                                        <div v-else class="pl-2"><i class="fas fa-blank fa-fw fa-lg"></i></div>
                                    </div>                                    
                                </div>                                                                                                                       
                            </td>                                
                        </tr>                                       
                        <template v-if="transmission.detail_visible">
                            <tr class="detail-row" :key="'transmission-' + transmission.id + 'recipients-header'">
                                <td colspan="7" class="pl-1 font-weight-bold">Recipient(s):</td>
                            </tr>
                            <tr v-for="(recipient, index) in transmission.recipient_list" :key="'transmission-' + transmission.id + '-recipient-' + recipient.destination + '-' + index" :class="['detail-row', {'font-weight-bold': recipient.primary_destination}]">
                                <td colspan="4">
                                    <div class="d-flex pl-3">
                                        <div><i v-if="recipient.revoked_at" class="fas fa-ban fa-sm text-danger status-icon" title="Email Link Revoked"></i></div>   
                                        <div class="px-1" :title="recipient.status.description">
                                            <i :class="recipientStatusIcon(recipient.transmission_method_id, recipient.status_code)"></i>
                                        </div>
                                        <div v-if="recipient.name" class="pl-0 pr-2 col-sm-5 text-truncate" :title="recipient.name">{{ recipient.name }}</div>                                                        
                                        <div v-if="recipient.transmission_method_id === TransmissionMethod.FAX">{{ recipient.destination | telephone }}</div>
                                        <div v-else>{{ recipient.destination }}</div>
                                    </div>                                              
                                </td>
                                <td>
                                    <div v-if="recipient.transmission_method_id === TransmissionMethod.FAX">{{ recipient.faxed_by.last_name }}</div>
                                    <div v-else-if="recipient.transmission_method_id === TransmissionMethod.EMAIL">{{ recipient.emailed_by.last_name }}</div>
                                    <div v-else-if="recipient.transmission_method_id === TransmissionMethod.MAILED">{{ recipient.mailed_by.last_name }}</div>
                                    <div v-else>N/A</div>
                                </td>
                                <td>
                                    <span v-if="recipient.transmission_method_id === TransmissionMethod.MAILED">{{ recipient.completed_at | localizeTime('YYYY-MM-DD') }}</span>
                                    <span v-else>{{ recipient.completed_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</span>
                                </td>
                                <td class="text-right">
                                    <div class="d-flex justify-content-end pr-3">
                                        <div v-if="recipient.transmission_method_id === TransmissionMethod.EMAIL" class="px-2">
                                            <a  href="javascript:void(0)" class="btn btn-link btn-sm p-0" title="Revoke Email Link" @click="revoke(recipient.id)">
                                                <span class="fa-stack fa-xs">
                                                    <i class="fas fa-link fa-stack-1x fa-lg"></i>
                                                    <i class="fas fa-ban fa-stack-2x text-danger"></i>
                                                </span>
                                            </a>
                                        </div>
                                        <div class="pr-2">                                                                
                                            <a v-if="recipient.confirmationUrl" :href="recipient.confirmationUrl" target="_blank" class="btn btn-link btn-sm p-0" title="View Confirmation">
                                                <i class="fas fa-clipboard-check fa-lg"></i>
                                            </a>
                                            <i v-else class="fas fa-clipboard-check fa-lg text-muted"></i>
                                        </div>
                                        <div>
                                            <button v-if="recipient.transmission_method_id !== TransmissionMethod.MAILED" class="btn btn-link btn-sm p-0" title="Resend" @click="resend(recipient, transmission)" :disabled="transmission.transmissions_disabled">
                                                <i class="fas fa-redo-alt fa-lg"></i>
                                            </button>
                                            <i v-else class="fas fa-redo-alt fa-lg icon-hidden"></i>
                                        </div>                                                                                                                                                                                          
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </template>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td class="pt-3" colspan="7">
                            <div v-if="isLoading" class="pt-3">            
                                <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
                            </div>
                            <h2 v-else class="text-muted text-center">No Sent Items</h2>
                        </td>
                    </tr>
                </tbody>
            </table>            
        </div>

        <div class="d-flex">
            <nav v-if="pageCount > 1" aria-label="Page navigation">
                <ul class="pagination">
                    <li v-bind:class="['page-item', { 'disabled' : currentPage == 1 }]">
                        <a class="page-link" href="#" @click="first()">
                            <span id="first-page"><i class="fas fa-step-backward fa-xs chev-pos"></i></span>
                        </a>
                    </li>                
                    <li v-bind:class="['page-item', { 'disabled' : currentPage == 1 }]">
                        <a class="page-link" href="#" @click="previous()">
                            <span id="previous"><i class="fas fa-chevron-left fa-xs chev-pos"></i><i class="fas fa-chevron-left fa-xs mr-1 chev-pos"></i>Previous</span>
                        </a>
                    </li>
                    <li v-bind:class="['page-item', { 'disabled' : currentPage == pageCount }]">
                        <a class="page-link" href="#" @click="next()">
                            <span id="next">Next<i class="fas fa-chevron-right fa-xs ml-2 chev-pos"></i><i class="fas fa-chevron-right fa-xs chev-pos"></i></span>
                        </a>
                    </li>
                    <li v-bind:class="['page-item', { 'disabled' : currentPage == pageCount }]">
                        <a class="page-link" href="#" @click="last()">
                            <span id="first-page"><i class="fas fa-step-forward fa-xs chev-pos"></i></span>
                        </a>
                    </li>                 
                </ul>
            </nav>
            <div class="ml-auto"> Page {{ currentPage }} of {{ pageCount }}</div>
        </div>
    </div>
</template>

<script>
import { TransmissionStatus, TransmissionMethod, FaxStatus, EmailStatus, MailedStatus } from '../../constants.js';
import TransmissionFilterModal from './TransmissionFilterComponent.vue';
import ForwardTransmissionModal from './ForwardTransmissionComponent.vue';
import TransmitButton from '../buttons/TransmitButtonComponent.vue';
import TransmissionDetailsModal from './TransmissionDetailsComponent.vue';

export default {
    components: {
        TransmissionFilterModal,
        ForwardTransmissionModal,
        TransmitButton,
        TransmissionDetailsModal
    },    
    props: {
        clients: Array,
        emailEnabled: Boolean
    },
    data() {
        return {
            // import constants into the template
            TransmissionStatus: TransmissionStatus,
            TransmissionMethod: TransmissionMethod,
            FaxStatus: FaxStatus,
            EmailStatus: EmailStatus,
            MailedStatus: MailedStatus,

            clientId: '',
            transmissions: [],
            contacts: [],
            statusOptions: [],
            typeOptions: [],
            methodOptions: [],
            initiatorOptions: [],            
            filters: {
                transmission_status_code: null,
                document_type_id: null,
                transmission_method_id: null,
                initiated_by: null,
                initiated_at: {
                    begin: null,
                    end: null
                }
            },
            timezone: null,
            currentPage: 1,
            pageCount: 0,
            isLoading: true
        }
    },
    methods: {
        refresh: function () {

            this.isLoading = true;
            let url = this.clientId ? '/ajax/clients/' + this.clientId + '/transmissions' : '/ajax/transmissions';
            axios.get(url, {
                params: {
                    page: this.currentPage,
                    timezone: this.timezone,
                    transmission_status_code: this.filters.transmission_status_code,
                    document_type_id: this.filters.document_type_id,
                    transmission_method_id: this.filters.transmission_method_id,
                    initiated_by: this.filters.initiated_by,
                    initiated_at_begin: this.filters.initiated_at.begin,
                    initiated_at_end: this.filters.initiated_at.end,
                }
            })
            .then(response => {

                this.transmissions = response.data.transmissions.map(e => {

                    // we want to retain detail visible state if we can
                    let transmission = this.transmissions.find(x => x.id === e.id);
                    let value = transmission ? transmission.detail_visible : false;
                    this.$set(e, 'detail_visible', value); 
                    return e; 
                });

                this.contacts = response.data.contacts;
                this.statusOptions = response.data.status_options;
                this.typeOptions = response.data.type_options;
                this.methodOptions = response.data.method_options;
                this.initiatorOptions = response.data.initiator_options;
                this.pageCount = response.data.page_count;
                this.isLoading = false;                
            })
            .catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        onChange: function (e) {

            // reset the current page and refresh
            this.currentPage = 1;
            this.refresh();
        },
        revoke: function (id) {
            axios.get('/email/revoke/' + id)
                .then(response => {
                    this.refresh();
                })
                .catch(error => {

                });
        },
        transmissionStatusIcon: function (code) {
            let retval = 'fas fa-question-circle fa-lg text-secondary';
            switch(code) {
                case TransmissionStatus.SUCCESS:
                    retval = 'fas fa-check-circle fa-lg text-success';
                    break;
                case TransmissionStatus.WARNING:
                    retval = 'fas fa-exclamation-triangle fa-lg text-warning';
                    break;
                case TransmissionStatus.FAILURE:
                    retval = 'fas fa-exclamation-circle fa-lg text-danger';
                    break;
                case TransmissionStatus.IN_PROGRESS:
                    retval = 'fas fa-spinner fa-spin fa-lg text-secondary';
                    break;
            }
            return retval; 
        },
        recipientStatusIcon: function (method, code) {
            let retval = 'fas fa-question-circle fa-sm text-secondary status-icon';

            if (method === TransmissionMethod.FAX) {
                if (code < FaxStatus.DOCUMENT_SENT) { retval = 'fas fa-spinner fa-spin fa-sm text-secondary status-icon'; }
                else if (code === FaxStatus.DOCUMENT_SENT) { retval = 'fas fa-check-circle fa-sm text-success status-icon'; }
                else if (code > FaxStatus.DOCUMENT_SENT) { retval = 'fas fa-exclamation-circle fa-sm text-danger status-icon'; }
            }
            else if (method === TransmissionMethod.EMAIL) {
                if (code === EmailStatus.PREPROCESSING) { retval = 'fas fa-spinner fa-spin fa-sm text-secondary status-icon'; }
                else if (code === EmailStatus.SENT) { retval = 'fas fa-clock fa-sm text-primary status-icon'; }
                else if (code === EmailStatus.EXPIRED) { retval = 'fas fa-clock fa-sm text-danger status-icon'; }
                else if (code === EmailStatus.DOWNLOADED) { retval = 'far fa-check-circle fa-sm text-success status-icon'; }
                else if (code === EmailStatus.CONFIRMED) { retval = 'fas fa-check-circle fa-sm text-success status-icon'; }
                else if (code === EmailStatus.ERROR) { retval = 'fas fa-exclamation-circle fa-sm text-danger status-icon'; }
            }
            else if (method === TransmissionMethod.MAILED) {
                if (code === MailedStatus.MAILED) { retval = 'far fa-check-circle fa-sm text-success status-icon'; }
                else if (code === MailedStatus.RECEIVED) { retval = 'fas fa-check-circle fa-sm text-success status-icon'; }
            }            

            return retval;
        },
        clickForward: function (method, transmission) {
            eventHub.$emit('show-forward-transmission', method, transmission);
        },
        resend: function (recipient, transmission) {
            recipient.status.value = transmission.transmission_method_id === TransmissionMethod.FAX ? FaxStatus.PREPROCESSING : EmailStatus.PREPROCESSING;
            axios.post('/ajax/transmissions/' + transmission.id + '/resend', {
                destination: recipient
            })
            .then(response => {
                toastr['success'](response.data.message, null, { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
            })
            .catch(error => {
                toastr['error'](error.response.data.message, null, { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
            });
        },
        showFilters: function () {
            eventHub.$emit('show-transmission-filters', 
                this.statusOptions,
                this.typeOptions,
                this.methodOptions,
                this.initiatorOptions,
                this.filters
            );
        },
        filter: function (filters) {
            this.filters = filters;
            this.currentPage = 1;
            this.refresh();
        },
        first: function () {
            if (this.currentPage > 1) {
                this.currentPage = 1;
                this.refresh();
            }
        },        
        previous: function() {
            if (this.currentPage > 0) {
                this.currentPage--;
                this.refresh();
            }
        },
        next: function() {
            if (this.currentPage < this.pageCount) {
                this.currentPage++;
                this.refresh();
            }
        },
        last: function () {
            if (this.currentPage < this.pageCount) {
                this.currentPage = this.pageCount;
                this.refresh();
            }
        },
        listen: function (newValue, oldValue) {
            const self = this;

            let oldChannels = oldValue ? [ oldValue ] : self.clients.map(e => e.id);
            oldChannels.forEach(x => {
                window.Echo.leave('transmission-event.' + x);
            });

            let newChannels = newValue ? [ newValue ] : self.clients.map(e => e.id);
            newChannels.forEach(x => {
                window.Echo.private('transmission-event.' + x).listen('TransmissionEvent', (e) => {
                    self.refresh();
                });
            });
        },
        showDocuments: function (transmission) {
            eventHub.$emit('show-transmission-details', transmission);
        }
    },
    created() {
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.clientId = this.clients.length == 1 ? this.clients[0].id : '';

        // listen for transmission events for selected client
        this.listen(this.clientId, null);

        this.refresh();
    },
    watch: {
        clientId: function (newValue, oldValue) {
            this.listen(newValue, oldValue);
        }
    }
}
</script>

<style scoped>
    .table-stripe  {
        background-color:rgba(0,0,0,.05);
    }

    .detail-row > td {
        border: none;
        padding: 0;
    }

    .status-icon {
        position: relative;
        top: -3px;
    }

    .icon-hidden {
        color: transparent; 
    }    
</style>